import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import App from './App.tsx'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Создаем элемент для предотвращения белого экрана
const loadingElement = document.createElement('div');
loadingElement.style.cssText = `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #181A20;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;
loadingElement.innerHTML = `
  <div style="
    width: 40px;
    height: 40px;
    border: 3px solid #353945;
    border-top: 3px solid #6366f1;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  "></div>
  <style>
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  </style>
`;

document.body.appendChild(loadingElement);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)

// Удаляем элемент загрузки после рендера приложения
setTimeout(() => {
  if (loadingElement.parentNode) {
    loadingElement.parentNode.removeChild(loadingElement);
  }
}, 100); 